const ftsSurvey = (() => {
  // Stores all responses
  const responses = {};
  
  // Track current visible step
  let currentStep = 'fts-intro';
  
  // Total steps for progress bar (approximate)
  const TOTAL_STEPS = 15;
  
  // Add this at the top of the IIFE, with the other variables
  const history = [];
  
  // Update goTo() to track history
  function goTo(stepId) {
    history.push(currentStep); // save where we came from
    document.getElementById(currentStep).style.display = 'none';
    document.getElementById(stepId).style.display = 'block';
    currentStep = stepId;
    updateProgress(); 
  }

  // Add this new function
  function goBack() {
    if (history.length === 0) return;
    const prevStep = history.pop();
    document.getElementById(currentStep).style.display = 'none';
    document.getElementById(prevStep).style.display = 'block';
    currentStep = prevStep;
    updateProgress();
  }

  // Starting the survey
  function startSurvey() {
    goTo('fts-step-1');
  }


  // ------------------------------------
  // Handle age step (single select with Next button)
  // ------------------------------------
  function submitAge() {
    const selected = document.querySelector('#fts-age-options .fts-opt.selected');
  
    if (!selected) {
      alert('Please select your age range.');
      return;
    }

    const val = selected.dataset.val;
    responses['age'] = val;
    console.log('Survey response: age →', val);

    if (val === 'under18') {
      submitResponses();
      applyDiscount('FTWSURVEY5');
      goTo('fts-end-a');
      return;
    } 

    goTo('fts-step-1b');
  }

  // ------------------------------------
  // Country list + filter
  // ------------------------------------
  const COUNTRIES = [
    'Afghanistan','Albania','Algeria','Andorra','Angola','Argentina','Armenia',
    'Australia','Austria','Azerbaijan','Bahrain','Bangladesh','Belarus','Belgium',
    'Bolivia','Bosnia and Herzegovina','Brazil','Brunei','Bulgaria','Cambodia',
    'Cameroon','Canada','Chile','China','Colombia','Croatia','Cuba','Cyprus',
    'Czech Republic','Denmark','Ecuador','Egypt','Estonia','Ethiopia','Finland',
    'France','Georgia','Germany','Ghana','Greece','Guatemala','Honduras',
    'Hong Kong','Hungary','India','Indonesia','Iran','Iraq','Ireland','Israel',
    'Italy','Jamaica','Japan','Jordan','Kazakhstan','Kenya','Kuwait','Kyrgyzstan',
    'Laos','Latvia','Lebanon','Libya','Lithuania','Luxembourg','Macau','Malaysia',
    'Maldives','Malta','Mexico','Moldova','Mongolia','Morocco','Mozambique',
    'Myanmar','Nepal','Netherlands','New Zealand','Nigeria','North Korea','Norway',
    'Oman','Pakistan','Palestine','Panama','Paraguay','Peru','Philippines','Poland',
    'Portugal','Qatar','Romania','Russia','Saudi Arabia','Senegal','Serbia',
    'Singapore','Slovakia','Slovenia','Somalia','South Africa','South Korea',
    'Spain','Sri Lanka','Sudan','Sweden','Switzerland','Syria','Taiwan',
    'Tajikistan','Tanzania','Thailand','Tunisia','Turkey','Turkmenistan','Uganda',
    'Ukraine','United Arab Emirates','United Kingdom','United States','Uruguay',
    'Uzbekistan','Venezuela','Vietnam','Yemen','Zambia','Zimbabwe'
  ];

  function filterCountries(query) {
    const list = document.getElementById('fts-country-list');
    list.style.display = 'block';
    const filtered = COUNTRIES.filter(c =>
      c.toLowerCase().includes(query.toLowerCase())
    );
    if (filtered.length === 0) {
      list.innerHTML = '<li style="color:#666;">No results</li>';
      return;
    }
    list.innerHTML = filtered.map(c =>
      `<li onclick="ftsSurvey.selectCountry('${c}')">${c}</li>`
    ).join('');
  }

  function selectCountry(name) {
    document.getElementById('fts-country-search').value = name;
    document.getElementById('fts-country-value').value = name;
    document.getElementById('fts-country-list').style.display = 'none';
  }

  function submitCountry() {
    const val = document.getElementById('fts-country-value').value
              || document.getElementById('fts-country-search').value;
    if (!val) {
      alert('Please select your country.');
      return;
    }
    responses['country'] = val;
    console.log('Survey response: country →', val);
    document.getElementById('fts-country-list').style.display = 'none';
    goTo('fts-step-2');
  }

  // ------------------------------------
  // Update progress bar
  // ------------------------------------
  function updateProgress() {
  const pct = Math.min((history.length / TOTAL_STEPS) * 100, 100);
  document.getElementById('fts-progress').style.width = pct + '%';
  }


  // ------------------------------------
  // Open modal
  // ------------------------------------
  function open() {
    document.getElementById('fantech-survey-overlay').style.display = 'flex';
    document.body.style.overflow = 'hidden';
    goTo('fts-intro');
  }

  // ------------------------------------
  // Close modal
  // ------------------------------------
  function close() {
    document.getElementById('fantech-survey-overlay').style.display = 'none';
    document.body.style.overflow = '';
  }

  // ------------------------------------
  // Handle single-select answers + branching
  // ------------------------------------
  function answer(key, val) {
    responses[key] = val;
    console.log('Survey response:', key, '→', val);

    // ---- BRANCHING LOGIC ----

    // Step 1: Age gate
    if (key === 'age') {
      if (val === 'under18') {
        goTo('fts-end-a'); // 5% discount ending
        submitResponses(); // still collect the data
        applyDiscount('FTWSURVEY5');
        return;
      }
      goTo('fts-step-1b');
      return;
    }

    // Step 1b : Country -> Step 2
    if (key === 'country') { goTo('fts-step-2'); return; }

    // Step 2: Purchase status
    if (key === 'status') {
      if (val === 'planning')    { goTo('fts-step-3a'); return; }
      if (val === 'considering') { goTo('fts-step-3b'); return; }
      if (val === 'returning')   { goTo('fts-step-3c'); return; }
    }

    // Branch 1 answer → continue main flow
    if (key === 'branch1') { goTo('fts-step-3d'); return; }

    // Branch 2 answer
    if (key === 'branch2') {
      if (val === 'comparing') { goTo('fts-step-3b-follow'); return; } // show brand input
      goTo('fts-step-3d');
      return;
    }

    // Branch 2 follow-up (competing brands)
    if (key === 'competing_brands') { goTo('fts-step-3d'); return; }

    // Branch 3 answer → continue main flow
    if (key === 'branch3') { goTo('fts-step-3d'); return; }

    // Step 6: First awareness → Step 7
    if (key === 'first_aware') { goTo('fts-step-7'); return; }

    // Step 7: Convincing source
    if (key === 'convincing') {
      if (val === 'influencer') { goTo('fts-step-7-influencer'); return; }
      goTo('fts-step-8');
      return;
    }

    // Step 7 influencer follow-up
    if (key === 'influencer_name') { goTo('fts-step-8'); return; }

    // Step 8: Content type → Step 9
    if (key === 'content_type') { goTo('fts-step-9'); return; }

    // Step 9: Product considered → Step 10
    if (key === 'product_considered') { goTo('fts-step-10'); return; }

    // Step 10: Feedback → Final submit
    if (key === 'feedback') {
      submitResponses();
      applyDiscount('FTWSURVEY15');
      goTo('fts-end-b');
      return;
    }
  }

  // ------------------------------------
  // Handle multi-select answers
  // ------------------------------------
  function submitMulti(key, containerId, maxSelect) {
    const selected = [...document.querySelectorAll(`#${containerId} .fts-opt.selected`)]
      .map(b => b.dataset.val);
    
    if (selected.length === 0) {
      alert('Please select at least one option.');
      return;
    }

    responses[key] = selected;
    console.log('Survey response:', key, '→', selected);

    // Buy channel -> step 3e
    if (key === 'buy_channel') {goTo('fts-step-3e'); return; }

    // Buy reason -> step 4
    if (key === 'buy_reason') {goTo('fts-step-4'); return; }
      
    // Branching from usage (Step 4)
    if (key === 'usage') {
      const isGamer = selected.includes('esports') || selected.includes('casual');
      if (isGamer) { goTo('fts-step-4-games'); return; }
      goTo('fts-step-5');
      return;
    }

    // Game types → Step 5
    if (key === 'game_types') { goTo('fts-step-5'); return; }

    // Considerations → Step 6
    if (key === 'considerations') { goTo('fts-step-6'); return; }
  }

  // ------------------------------------
  // Apply discount via Storefront API
  // ------------------------------------
  async function applyDiscount(code) {
    try {
      // Get cart token
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      
      // Apply discount code
      await fetch('/discount/' + code, { method: 'GET' });
      console.log('Discount applied:', code);
    } catch (err) {
      console.warn('Discount apply failed:', err);
    }
  }

  // ------------------------------------
  // Submit responses to your endpoint
  // (replace URL with your Google Sheets / Make.com webhook)
  // ------------------------------------
  async function submitResponses() {
    const WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbzSH_xlvtrZcuf68K7BgL4V0Z6dozq4uG8Z9O81CNDZ9r1OGBXAe7PJjZBMH2XPrJLGJA/exec'; 
    
    try {
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          timestamp: new Date().toISOString(),
          ...responses
        })
      });
      console.log('Responses submitted:', responses);
    } catch (err) {
      console.warn('Submission failed:', err);
    }
  }

  // ------------------------------------
  // Multi-select toggle handler
  // ------------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.fts-check').forEach(btn => {
      btn.addEventListener('click', function () {
        const container = this.closest('.fts-multi');
        if (!container) return;
        const maxAttr = container.id === 'fts-consider-options' ? 3
                      : container.id === 'fts-buychannel-options' ? 3
                      : container.id === 'fts-buyreason-options' ? 3
                      : container.id === 'fts-age-options' ? 1
                      : 2;
        const selected = container.querySelectorAll('.selected');
        
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
        } else if (selected.length < maxAttr) {
          this.classList.add('selected');
        }
      });
    });

    // Close overlay on background click
    document.getElementById('fantech-survey-overlay')
      ?.addEventListener('click', function(e) {
        if (e.target === this) close();
      });

    // Close country dropdown on outside click
    document.addEventListener('click', function(e) {
      const wrap = document.getElementById('fts-country-search');
      const list = document.getElementById('fts-country-list');
      if (list && wrap && !wrap.contains(e.target) && !list.contains(e.target)) {
        list.style.display = 'none';
      }
    });

  }); // Closing DOMContentLoaded

  return { startSurvey, open, close, answer, submitMulti, goBack, submitAge, filterCountries, selectCountry, submitCountry};
})();
